module.exports = __webpack_public_path__ + "img/donante-bellydance-evolution.108f83b9.jpeg";